import { render, staticRenderFns } from "./skillCourse.vue?vue&type=template&id=49309dc2&scoped=true&"
import script from "./skillCourse.vue?vue&type=script&lang=js&"
export * from "./skillCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49309dc2",
  null
  
)

export default component.exports